// extracted by mini-css-extract-plugin
export var rive = "rive-module--rive--d0d58";